import { render } from "./icon-ionic.vue?vue&type=template&id=9d1e80f0"
import script from "./icon-ionic.vue?vue&type=script&lang=js"
export * from "./icon-ionic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__